import Link from "@components/core/Link";

function BrandLetterGroup({ letters, brandsByLetter }) {
  return (
    <div className="brand-list">
      {letters.map((letter) => (
        <div
          key={letter}
          className="brand-letter-group"
          id={letter}
        >
          <h5 className="py-3">{letter}</h5>
          <div className="brand-items">
            {brandsByLetter[letter].map((brand) => (
              <Link
                key={brand.id}
                href={`/marques/${brand.slug}`}
                prefetch={false}
                className="link-primary"
                noUnderline
              >
                <div className="mb-2">{brand.name}</div>
              </Link>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

export default BrandLetterGroup;
